export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8168.b85ef3f4.jpg";